var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Col, Select } from '@folio/stripes/components';
import React, { useMemo } from 'react';
import { Field, useField } from 'react-final-form';
import { FormattedMessage } from 'react-intl';
import { useCampuses, useInstitutions, useLibraries, useLocations } from '../../api/queries';
export default function CriteriaLocation(_a) {
    var prefix = _a.prefix;
    var institutions = useInstitutions();
    var campuses = useCampuses();
    var libraries = useLibraries();
    var locations = useLocations();
    var selectedInstitution = useField("".concat(prefix, "institutionId"), {
        subscription: { value: true },
    }).input.value;
    var selectedCampus = useField("".concat(prefix, "campusId"), {
        subscription: { value: true },
    }).input.value;
    var selectedLibrary = useField("".concat(prefix, "libraryId"), {
        subscription: { value: true },
    }).input.value;
    var institutionSelectOptions = useMemo(function () {
        if (!institutions.isSuccess) {
            return [{ label: '', value: undefined }];
        }
        return __spreadArray([
            { label: '', value: undefined }
        ], institutions.data
            .map(function (institution) { return ({
            label: institution.name,
            value: institution.id,
        }); })
            .sort(function (a, b) { return a.label.localeCompare(b.label); }), true);
    }, [institutions]);
    var campusSelectOptions = useMemo(function () {
        if (!selectedInstitution || !campuses.isSuccess) {
            return [{ label: '', value: undefined }];
        }
        return __spreadArray([
            { label: '', value: undefined }
        ], campuses.data
            .filter(function (campus) { return campus.institutionId === selectedInstitution; })
            .map(function (campus) { return ({
            label: campus.name,
            value: campus.id,
        }); })
            .sort(function (a, b) { return a.label.localeCompare(b.label); }), true);
    }, [selectedInstitution, campuses]);
    var librarySelectOptions = useMemo(function () {
        if (!selectedCampus || !libraries.isSuccess) {
            return [{ label: '', value: undefined }];
        }
        return __spreadArray([
            { label: '', value: undefined }
        ], libraries.data
            .filter(function (library) { return library.campusId === selectedCampus; })
            .map(function (library) { return ({
            label: library.name,
            value: library.id,
        }); })
            .sort(function (a, b) { return a.label.localeCompare(b.label); }), true);
    }, [selectedCampus, libraries]);
    var locationSelectOptions = useMemo(function () {
        if (!selectedLibrary || !locations.isSuccess) {
            return [{ label: '', value: undefined }];
        }
        return __spreadArray([
            { label: '', value: undefined }
        ], locations.data
            .filter(function (location) { return location.libraryId === selectedLibrary; })
            .map(function (location) { return ({
            label: location.name,
            value: location.id,
        }); })
            .sort(function (a, b) { return a.label.localeCompare(b.label); }), true);
    }, [selectedLibrary, locations]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Col, { xs: 12, md: 6 },
            React.createElement(Field, { name: "".concat(prefix, "institutionId") }, function (fieldProps) { return (React.createElement(Select, __assign({}, fieldProps, { fullWidth: true, marginBottom0: true, required: true, label: React.createElement(FormattedMessage, { id: "ui-plugin-bursar-export.bursarExports.criteria.location.inst" }), dataOptions: institutionSelectOptions }))); })),
        React.createElement(Col, { xs: 12, md: 6 },
            React.createElement(Field, { name: "".concat(prefix, "campusId") }, function (fieldProps) { return (React.createElement(Select, __assign({}, fieldProps, { fullWidth: true, marginBottom0: true, required: true, label: React.createElement(FormattedMessage, { id: "ui-plugin-bursar-export.bursarExports.criteria.location.camp" }), dataOptions: campusSelectOptions }))); })),
        React.createElement(Col, { xs: 12, md: 6 },
            React.createElement(Field, { name: "".concat(prefix, "libraryId") }, function (fieldProps) { return (React.createElement(Select, __assign({}, fieldProps, { fullWidth: true, marginBottom0: true, required: true, label: React.createElement(FormattedMessage, { id: "ui-plugin-bursar-export.bursarExports.criteria.location.lib" }), dataOptions: librarySelectOptions }))); })),
        React.createElement(Col, { xs: 12, md: 6 },
            React.createElement(Field, { name: "".concat(prefix, "locationId") }, function (fieldProps) { return (React.createElement(Select, __assign({}, fieldProps, { fullWidth: true, marginBottom0: true, required: true, label: React.createElement(FormattedMessage, { id: "ui-plugin-bursar-export.bursarExports.criteria.location.loc" }), dataOptions: locationSelectOptions }))); }))));
}
